/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=8f316ae0&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=8f316ae0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f316ae0"]])

export default __exports__